// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-settings {
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  padding-top: 60px;
  padding-bottom: 60px;
}
.account-settings__card-profile-changes {
  margin: auto;
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.account-settings__card-password-change {
  margin: auto;
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-top: 20px;
}
.account-settings__head {
  display: flex;
  margin-bottom: 20px;
}
.account-settings__head__head-text {
  padding-left: 15px;
  padding-top: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
}

.profile-icon-svg {
  position: absolute;
  margin-left: 80px;
  margin-top: 80px;
  cursor: pointer;
}

.my-info {
  padding: 5%;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
}
.my-info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
}
.my-info__row {
  margin-top: 30px;
}
.my-info__profpic {
  display: flex;
  flex: 20% 1;
}
.my-info__profpic__image {
  height: 112px;
  width: 112px;
  border-radius: 50%;
}
.my-info__form {
  display: flex;
  margin-top: 30px;
  padding: 20px;
}
.my-info__submit-input {
  background: #566370;
  border: none;
  color: white;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

.profile-image {
  border-radius: 50%;
  height: 80px;
  width: 80px;
  object-fit: cover;
}

.form {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  width: 100%;
}
.form__input {
  border: 1px solid #e8e9e9;
  height: 50px;
  width: 100%;
}
.form__input-disabled {
  border: 1px solid #e8e9e9;
  height: 50px;
  width: 100%;
  background-color: #f3f5f6;
}
.form__birthday {
  display: flex;
  margin-top: 20px;
  width: 100%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.form__tel {
  display: flex;
  margin-top: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #999999;
}
.form__name {
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.text-input {
  flex: 1 1;
}

.inputArea {
  display: flex;
  flex: 1 1;
  position: relative;
}
.inputArea .count {
  display: flex;
  position: absolute;
  top: 20px;
  right: 20px;
  bottom: 0;
  align-items: center;
}
.inputArea .count span {
  color: #bd1823;
  font-size: 1.2rem;
  font-weight: 400;
}

.btnArea {
  display: flex;
  margin-left: 10px;
  width: 100px;
  align-items: flex-end;
}
.btnArea .button {
  height: 60px;
  color: #49ae9e;
  background: #e5f4f2;
}

.phoneBtnArea {
  display: flex;
  margin-left: 10px;
  width: 100px;
  align-items: flex-end;
}
.phoneBtnArea .button {
  height: 60px;
}

.phoneBtnArea.pwdAuth {
  width: 155px;
}

.password-change {
  display: flex;
  align-items: flex-end;
}
.password-change__input {
  flex: 70% 1;
}
.password-change__button {
  margin-left: 10px;
}

.password {
  padding: 5%;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
}
.password__row {
  display: flex;
  margin-top: 20px;
  padding: 20px;
}
.password__form {
  flex: 100% 1;
}
.password__submit {
  margin-top: 20px;
  float: right;
}
.password__submit-input {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #49ae9e;
  height: 60px;
  background: #e5f4f2;
  border-radius: 8px;
  border: none;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

.account-withdrawal {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  margin-top: 20px;
  padding-left: 30%;
}
.account-withdrawal__button {
  cursor: pointer;
  font-weight: 500;
  color: #333333;
  text-decoration-line: underline;
}

.error {
  color: #505054;
}

.change-password__row {
  display: flex;
  margin-top: 10px;
  padding: 20px;
}
.change-password__form {
  width: 100%;
  position: relative;
}
.change-password__send-auth {
  position: absolute;
  right: 10px;
  top: 24px;
  background: #566370;
  border: none;
  color: white;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

.change-password-form__message {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999;
}
.change-password-form__enter-password {
  position: relative;
}
.change-password-form__enter-password .hiddenBtn {
  display: flex;
  position: absolute;
  top: 20px;
  right: 20px;
  bottom: 0;
  align-items: center;
}
.change-password-form__reenter-password {
  display: flex;
  margin-top: 20px;
}

.change-password-submit {
  margin-top: 20px;
  float: right;
  display: flex;
}
.change-password-submit__cancel {
  margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/account-settings/account-settings.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AACJ;AACI;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AACR;AACI;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;AAAR;AAEQ;EACI,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAZ;;AAKA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAFJ;;AAKA;EACI,WAAA;EAEA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAHJ;AAKI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAHR;AAMI;EACI,gBAAA;AAJR;AAOI;EACI,aAAA;EACA,WAAA;AALR;AAOQ;EACI,aAAA;EACA,YAAA;EACA,kBAAA;AALZ;AASI;EACI,aAAA;EACA,gBAAA;EACA,aAAA;AAPR;AAUI;EACI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AARR;;AAaA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,WAAA;AAXJ;AAaI;EACI,yBAAA;EACA,YAAA;EACA,WAAA;AAXR;AAcI;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAZR;AAeI;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAbR;AAiBI;EACI,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAfR;AAkBI;EACI,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhBR;;AAoBA;EACI,SAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,SAAA;EACA,kBAAA;AAjBJ;AAmBI;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AAjBR;AAmBQ;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AAjBZ;;AAqBA;EACI,aAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;AAlBJ;AAmBI;EACI,YAAA;EACA,cAAA;EACA,mBAAA;AAjBR;;AAoBA;EACI,aAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;AAjBJ;AAkBI;EACI,YAAA;AAhBR;;AAmBA;EACI,YAAA;AAhBJ;;AAmBA;EACI,aAAA;EACA,qBAAA;AAhBJ;AAkBI;EACI,WAAA;AAhBR;AAmBI;EACI,iBAAA;AAjBR;;AAqBA;EACI,WAAA;EAEA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAnBJ;AAqBI;EACI,aAAA;EACA,gBAAA;EACA,aAAA;AAnBR;AAsBI;EACI,YAAA;AApBR;AAuBI;EACI,gBAAA;EACA,YAAA;AArBR;AAwBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAEA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAvBR;;AA2BA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAxBJ;AA0BI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;AAxBR;;AA4BA;EACI,cAAA;AAzBJ;;AA6BI;EACI,aAAA;EACA,gBAAA;EACA,aAAA;AA1BR;AA6BI;EACI,WAAA;EACA,kBAAA;AA3BR;AA8BI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EAEA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EAEA,eAAA;AA9BR;;AAmCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAhCR;AAmCI;EACI,kBAAA;AAjCR;AAmCQ;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AAjCZ;AAqCI;EACI,aAAA;EACA,gBAAA;AAnCR;;AAuCA;EACI,gBAAA;EACA,YAAA;EACA,aAAA;AApCJ;AAsCI;EACI,kBAAA;AApCR","sourcesContent":[".account-settings {\n    width: 100%;\n    height: 100%;\n    background: #f3f4f6;\n    padding-top: 60px;\n    padding-bottom: 60px;\n\n    &__card-profile-changes {\n        margin: auto;\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n    }\n    &__card-password-change {\n        margin: auto;\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        margin-top: 20px;\n    }\n\n    &__head {\n        display: flex;\n        margin-bottom: 20px;\n\n        &__head-text {\n            padding-left: 15px;\n            padding-top: 10px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n        }\n    }\n}\n\n.profile-icon-svg {\n    position: absolute;\n    margin-left: 80px;\n    margin-top: 80px;\n    cursor: pointer;\n}\n\n.my-info {\n    padding: 5%;\n\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n    }\n\n    &__row {\n        margin-top: 30px;\n    }\n\n    &__profpic {\n        display: flex;\n        flex: 20%;\n\n        &__image {\n            height: 112px;\n            width: 112px;\n            border-radius: 50%;\n        }\n    }\n\n    &__form {\n        display: flex;\n        margin-top: 30px;\n        padding: 20px;\n    }\n\n    &__submit-input {\n        background: #566370;\n        border: none;\n        color: white;\n        padding: 10px 32px;\n        text-align: center;\n        text-decoration: none;\n        display: inline-block;\n        font-size: 16px;\n        cursor: pointer;\n    }\n\n}\n\n.profile-image {\n    border-radius: 50%;\n    height: 80px;\n    width: 80px;\n    object-fit: cover;\n}\n\n.form {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n\n    width: 100%;\n\n    &__input {\n        border: 1px solid #e8e9e9;\n        height: 50px;\n        width: 100%;\n    }\n\n    &__input-disabled {\n        border: 1px solid #e8e9e9;\n        height: 50px;\n        width: 100%;\n        background-color: #f3f5f6;\n    }\n\n    &__birthday {\n        display: flex;\n        margin-top: 20px;\n        width: 100%;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n\n    }\n\n    &__tel {\n        display: flex;\n        margin-top: 20px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #999999;\n    }\n\n    &__name {\n        display: flex;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n}\n\n.text-input {\n    flex: 1;\n}\n\n.inputArea {\n    display: flex;\n    flex: 1;\n    position: relative;\n\n    .count {\n        display: flex;\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        bottom: 0;\n        align-items: center;\n\n        span {\n            color: #bd1823;\n            font-size: 1.2rem;\n            font-weight: 400;\n        }\n    }\n}\n.btnArea {\n    display: flex;\n    margin-left: 10px;\n    width: 100px;\n    align-items: flex-end;\n    .button {\n        height: 60px;\n        color: #49ae9e;\n        background: #e5f4f2;\n    }\n}\n.phoneBtnArea {\n    display: flex;\n    margin-left: 10px;\n    width: 100px;\n    align-items: flex-end;\n    .button {\n        height: 60px;\n    }\n}\n.phoneBtnArea.pwdAuth {\n    width: 155px;\n}\n\n.password-change {\n    display: flex;\n    align-items: flex-end;\n\n    &__input {\n        flex: 70%;\n    }\n\n    &__button {\n        margin-left: 10px;\n    }\n}\n\n.password {\n    padding: 5%;\n\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n\n    &__row {\n        display: flex;\n        margin-top: 20px;\n        padding: 20px;\n    }\n\n    &__form {\n        flex: 100%;\n    }\n\n    &__submit {\n        margin-top: 20px;\n        float: right;\n    }\n\n    &__submit-input {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        color: #49ae9e;\n\n        height: 60px;\n        background: #e5f4f2;\n        border-radius: 8px;\n        border: none;\n        padding: 10px 32px;\n        text-align: center;\n        text-decoration: none;\n        display: inline-block;\n        font-size: 16px;\n        cursor: pointer;\n    }\n}\n\n.account-withdrawal {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #999999;\n    margin-top: 20px;\n    padding-left: 30%;\n\n    &__button {\n        cursor: pointer;\n        font-weight: 500;\n        color: #333333;\n        text-decoration-line: underline;\n    }\n}\n\n.error {\n    color: #505054;\n}\n\n.change-password {\n    &__row {\n        display: flex;\n        margin-top: 10px;\n        padding: 20px;\n    }\n\n    &__form {\n        width: 100%;\n        position: relative;\n    }\n\n    &__send-auth {\n        position: absolute;\n        right: 10px;\n        top: 24px;\n\n        background: #566370;\n        border: none;\n        color: white;\n        padding: 10px 32px;\n        text-align: center;\n        text-decoration: none;\n        display: inline-block;\n        font-size: 16px;\n\n        cursor: pointer;\n    }\n}\n\n.change-password-form {\n    &__message {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999;\n    }\n\n    &__enter-password {\n        position: relative;\n\n        .hiddenBtn {\n            display: flex;\n            position: absolute;\n            top: 20px;\n            right: 20px;\n            bottom: 0;\n            align-items: center;\n        }\n    }\n\n    &__reenter-password {\n        display: flex;\n        margin-top: 20px;\n    }\n}\n\n.change-password-submit {\n    margin-top: 20px;\n    float: right;\n    display: flex;\n\n    &__cancel {\n        margin-right: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
